import InlineBtn from "components/shared/inlineBtn";
import { bidStatuses, bidStatusesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useEffect } from "react";
import { alert } from "services/alert";
import { sendBidsForFactoring } from "sources/books/bids";

const actions = [
    {
        title: "Факторинг",
        action: (props) => {
            const itemsWithLeaveDate = props.selectedItems.filter(
                (item) => !!(item.lastBidPoint.autoLeftAt || item.lastBidPoint.loadUnloadedAtByLogist),
            );
            return sendBidsForFactoring(itemsWithLeaveDate.map((item) => item.id)).then(() => {
                if (itemsWithLeaveDate.length !== props.selectedItems.length) {
                    alert({ message: "На факторинг были отправлены только заявки с датами выезда", type: "warning" });
                }
            });
        },
        disabled: (items) => items.some((item) => item.status !== bidStatusesEnum.Done),
        validationMessage: `Отправка на факторинг доступна только для заявок в статусе "${enumLabel(bidStatuses, bidStatusesEnum.Done)}"`,
    },
];

const MultipleActions = (props) => {
    useEffect(() => {
        resetItems();
    }, [props.isLoadingList]);
    const { getList, params, selectedItems, resetItems } = props;
    const hasSelectedItems = props.allItemsSelected || Object.values(props.selectedItems).find((item) => item);
    if (!hasSelectedItems) {
        return null;
    }
    const confirmModal = (action) =>
        props.modal({
            name: "confirm",
            title: "Вы уверены, что хотите выполнить действие?",
            action: () => action(props),
            onSuccessAction: () => getList(params),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    return (
        <div className="container-fluid pb-2">
            {actions.map((item) => (
                <InlineBtn
                    key={item.title}
                    value={item.title}
                    action={() => confirmModal(item.action)}
                    disabled={item.disabled(selectedItems)}
                    tooltip={item.validationMessage}
                />
            ))}
        </div>
    );
};

export default MultipleActions;
